import { render, staticRenderFns } from "./RecipientEditDialog.vue?vue&type=template&id=68d6fc4a&"
import script from "./RecipientEditDialog.vue?vue&type=script&lang=js&"
export * from "./RecipientEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./RecipientEditDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports